import { useEffect, useState } from 'react';

import { getIconModules } from './get-icon-modules.util';
import { iconsRegistry } from './icons-registry';

export interface DynamicIconProps {
  /* The id for the icon. Expected to match an id in ./icons-registry.ts */
  iconId: string;
  strokeColor?: string;
  strokeWidth?: number;
  className?: string;
  height?: number;
  width?: number;
  alt?: string;
}
const iconModules = getIconModules();

export const DynamicIcon = ({
  iconId,
  strokeColor,
  strokeWidth,
  className,
  height,
  width,
  alt,
}: DynamicIconProps) => {
  const [src, setSrc] = useState<string | undefined>(undefined);
  const iconName = iconsRegistry[iconId]?.name;

  const changeStrokeColor = (svg: string): string => {
    return svg.replace(
      /(stroke\s*=\s*)(['"])[^'"]*\2/g,
      `$1$2${encodeURIComponent(strokeColor!)}$2`,
    );
  };

  const changeStrokeWidth = (svg: string): string => {
    return svg.replace(
      /(stroke-width\s*=\s*)(['"])[^'"]*\2/g,
      `$1$2${encodeURIComponent(strokeWidth!)}$2`,
    );
  };

  const changeSvgAttributes = (svg: string): string => {
    let modifiedSvg = svg;

    if (strokeColor) {
      modifiedSvg = changeStrokeColor(modifiedSvg);
    }

    if (strokeWidth) {
      modifiedSvg = changeStrokeWidth(modifiedSvg);
    }

    return modifiedSvg;
  };

  useEffect(() => {
    if (!iconName || !iconId) {
      return;
    }

    const iconPath = `./assets/${iconName}.svg`;
    const importIcon = iconModules[iconPath];

    if (!importIcon) {
      return;
    }

    importIcon().then((svgDataUri: unknown) => {
      const url: string = svgDataUri as string;
      setSrc(changeSvgAttributes(url));
    });
  }, [iconId, strokeColor, strokeWidth]);

  if (!src) {
    return;
  }

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      height={height}
      width={width}
    />
  );
};
